module.exports = __webpack_public_path__ + "static/unlimited-task-7424da1e0c16f38aebf9eb29e6f0260e.png";